/**
 * @flow
 * @format
 */

import React from 'react';
// import { connect } from 'react-redux';
import _ from 'lodash/fp';
import cc from 'classcat';
import { Col } from 'reactstrap';
import FaFileText from 'react-icons/lib/fa/file-text';
// import { getFieldValues } from '~/selectors/design';
import { HashId, createHTMLMarkup } from '~/utils';

// import type { Connector } from 'react-redux';

import classes from './LargeTable.scss';

// import debug from '~/utils/macros/debug.macro';
type PropsType = {
  id: string,
  changed: boolean,
  changeInput: Function,
  defaultVal: number | string | null,
  error: string[],
  fieldName: ?(React$Element<*> | string),
  revertInput: Function,
  tooltip: ?React$Element<*>,
  value: number | string | null,
  warning: string[],
};

// type ReduxType = {
//   rowData: string[][],
//   rowHeader: string[],
// };

// type PropsType = ReduxType & OwnPropsType;

const hashId = new HashId();

function generateDataSheetLink(part) {
  return (
    <a
      href={`/PowerSolutions/supportDoc.do?type=Datasheets&part=${part}`}
      rel="noopener noreferrer"
      target="_blank"
    >
      <FaFileText style={{ color: 'black' }} />
    </a>
  );
}

function generateLink(part) {
  return (
    <div style={{ display: 'flex' }}>
      <a
        href={`/PowerSolutions/product.do?id=${part}`}
        rel="noopener noreferrer"
        target="_blank"
        style={{ flex: 1 }}
      >
        {part}
      </a>
      {generateDataSheetLink(part)}
    </div>
  );
}

const getHeader = (str: string) => {
  switch (str) {
    case 'Configuration':
      return 'Cfg';
    default:
      return str;
  }
};

export class LargeTable extends React.Component<PropsType, *> {
  static defaultProps = {
    rowHeader: [],
    rowData: [],
    error: [],
    warning: [],
  };

  props: PropsType;

  // shouldComponentUpdate(nextProps: PropsType) {
  //   const subProps = _.pick([
  //     'changed',
  //     'defaultVal',
  //     'dirty',
  //     'error',
  //     'evaluating',
  //     'rowData',
  //     'warning',
  //   ]);
  //   return deepDiffer(subProps(this.props), subProps(nextProps));
  // }

  render() {
    const hasError = this.props.error.length > 0;
    const hasWarning = this.props.warning.length > 0;

    const errorOrWarning = (text: string[]) => (
      <Col>
        <div className="pt-2 pl-2 pr-2 d-flex">
          {this.props.fieldName}
          {this.props.tooltip}
        </div>
        <div className="pt-3 pb-3 pl-2">
          <p>{text}</p>
        </div>
      </Col>
    );

    // Handle any errors for this field
    if (hasError) {
      return errorOrWarning(this.props.error);
    }

    if (hasWarning) {
      return errorOrWarning(this.props.warning);
    }

    const rowHeader: string[] = _.head((this.props.value: any));
    const rowData: string[][] = _.tail((this.props.value: any));

    if (!rowHeader) return null;

    const tHeader = rowHeader.map(s => {
      let title = getHeader(s);

      if (title) {
        title = title.replace(/\s@\s/g, '<br/>@&nbsp;');
        title = title.replace(/\)\smax/g, ')<br/>max');
        // title = title.replace(/RDS/g, 'RDS<br />');
        title = title.replace(/ID\scont/g, 'ID&nbsp;cont');
        const index = title.lastIndexOf(' ');
        title =
          index === -1
            ? title
            : `${title.slice(0, index)}</br>${title.slice(index + 1)}`;
      }

      return (
        <th className="sticky-top" key={hashId.nextId()}>
          {createHTMLMarkup(title) || <span>&nbsp;</span>}
        </th>
      );
    });
    const tRows = rowData.map((r: string[], k: number) => {
      const id = hashId.nextId();
      return (
        <tr key={id} className={cc([classes.partRow])}>
          {r.map((d, l) => (
            <td key={hashId.encode(`${k}${l}`)}>
              {l === 0 ? generateLink(d) : d}
            </td>
          ))}
        </tr>
      );
    });

    return (
      <Col>
        <div className="pt-2 pl-2 pr-2 d-flex">
          {this.props.fieldName}
          {this.props.tooltip}
        </div>
        <div className={classes.scrollable}>
          <table className={classes.tableFixed}>
            <thead className="thead-inverse">
              <tr>{tHeader}</tr>
            </thead>
            <tbody>{tRows}</tbody>
          </table>
        </div>
      </Col>
    );
  }
}

// function mapStateToProps(
//   state: AppStateType,
//   ownProps: OwnPropsType,
// ): PropsType {
//   const values = getFieldValues(state);
//   const data: { currentValue: any } = values[ownProps.id];
//   const tableData: string[][] = data.currentValue || [[]];

//   return {
//     ...ownProps,
//     rowData: _.tail(tableData),
//     rowHeader: _.head(tableData),
//   };
// }

// const connector: Connector<OwnPropsType, PropsType> = connect(mapStateToProps);

export default LargeTable;



// WEBPACK FOOTER //
// ./src/components/LargeTable/LargeTable.js